<template>
    <div class="c-instance-selector">
        <DynamicList
                ref="dynamicList"
                :caption="caption"
                :retrieveOnMount="retrieveOnMount"
                :subCaption="subCaption"
                :searchFormStructure="searchFormStructure"
                :columns="columns"
                :searchArgs="searchArgs"
                :options="options"
                :root="root">
        </DynamicList>
    </div>
</template>

<script>
    import DynamicList from './DynamicList'
    export default {
        name: 'InstanceSelector',
        components: {
            DynamicList,
        },
        props: {
            retrieveOnMount: {
                type: Boolean,
                default: true
            },
            root: {
                type: String,
                required: true
            },
            caption: {
                type: String,
                default: ''
            },
            subCaption: {
                type: String,
                default: ''
            },
            searchFormStructure: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            columns: {
                type: Array,
                default: function () {
                    return []
                }
            },
            searchArgs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            value: {
                type: Array,
                default: function () {
                    return []
                }
            },
            multiple: {
                type: Boolean,
                default: false
            },
            quantity: {
                type: Boolean,
                default: true
            },
            distinct: {
                type: Boolean,
                default: false
            },
            distinctFunction: {
                type: Function,
                default: function () {
                    return false
                }
            },
            form: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            },
            fieldRefs: {
                type: Array,
                default: function () {
                    return []
                }
            },
            options: {
                type: Object,
                default: function () {
                    return {
                        pagination: true,
                        header: true,
                        responsive: false,
                        striped: true,
                        headerStyle: '1',
                        emptyText: 'Aucun résultat',
                        borderVariant: '',
                        noBody: false
                    }
                }
            },
            quantityStep: {
                type: Number | String,
                default: 1
            },
            data: {
                type: Object,
                default: function () {
                    return {
                    }
                }
            }
        },
        watch: {
            value: {
                handler(val) {
                    this.dataInstances = val
                },
                deep: true
            }
        },
        mounted() {
            this.dataInstances = this.value
            this.addActions()
        },
        data: () => {
            return {
                dataInstances: [],
                dataQuantityStep: 1
            }
        },
        methods: {
            addActions() {
                if (this.$refs.dynamicList !== undefined) {
                    this.$refs.dynamicList.$refs.list.addAction('add', this.add, '', '<button type="button" class="btn btn-light btn-sm"><i class="fa fa-plus"></i></button>', '', 'width:90px', 'left')
                }
            },
            add(value, cell, row, rowIndex, columnIndex, component) {

                this.dataQuantityStep = this.quantityStep
                if (isNaN(this.dataQuantityStep)) {
                    if (row[this.dataQuantityStep] !== undefined && !isNaN(row[this.dataQuantityStep])&& row[this.dataQuantityStep]>0) {
                        this.dataQuantityStep = row[this.dataQuantityStep]
                    } else {
                        this.dataQuantityStep = 1
                    }
                } else {
                    this.dataQuantityStep = 1
                }

                let instance = Core.Array.newObject(row)
                if (instance.add !== undefined) {
                    instance.add = ''
                }
                if (this.multiple) {
                    let instanceIndex = Core.Array.findIndexByKey(this.dataInstances, 'id', row.id)

                    if ((this.distinct === true && instanceIndex === false) || (this.distinct === false && this.distinctFunction(instance) === false)) {
                            let quantity = this.dataQuantityStep
                            if (!instanceIndex) {
                                this.dataInstances.push({
                                    index: rowIndex,
                                    instance: instance,
                                    id: row.id,
                                    quantity: this.dataQuantityStep,
                                    data: this.data
                                })
                                this.$emit('onAdd', row, this.data)
                            } else {
                                this.dataInstances[instanceIndex].quantity = parseInt(this.dataInstances[instanceIndex].quantity) + parseInt(this.dataQuantityStep)
                                quantity = this.dataInstances[instanceIndex].quantity
                            }
                            if (this.distinct) {
                                cell.value = '<button type="button" class="btn btn-light btn-sm"><i class="fa fa-plus"></i></button>'
                            } else {
                                cell.value = '<button type="button" class="btn btn-light btn-sm"><i class="fa fa-plus mr-2"></i>' + quantity + '</button>'
                            }
                        } else {
                            if (!instanceIndex || this.distinctFunction(instance) === true) {
                                this.dataInstances.push({
                                    index: rowIndex,
                                    instance: instance,
                                    id: row.id,
                                    quantity: 1,
                                    data: this.data
                                })
                                this.$emit('onAdd', row, this.data)
                                cell.value = '<button type="button" class="btn btn-info btn-sm"><i class="fa fa-check"></i></button>'
                            } else {
                                if (this.dataInstances[instanceIndex].quantity === 1) {
                                    this.dataInstances[instanceIndex].quantity = 0
                                    cell.value = '<button type="button" class="btn btn-light btn-sm"><i class="fa fa-plus"></i></button>'
                                } else {
                                    this.dataInstances[instanceIndex].quantity = 1
                                    cell.value = '<button type="button" class="btn btn-info btn-sm"><i class="fa fa-check"></i></button>'
                                }
                            }
                        }
                } else {
                    this.dataInstances = [
                        {
                            index: rowIndex,
                            instance: instance,
                            id: row.id,
                            quantity: this.dataQuantityStep,
                            data: this.data
                        }
                    ]
                    this.$emit('onAdd', row, this.data)
                }
                this.$emit('input', this.dataInstances)
                component.$forceUpdate()
            }
        }
    }
</script>
